import BaseApi from './baseApi';
import IListAdressTypes from '../models/IListAdressTypes';
import IAuthentication from '../models/IAuthentication';
export default class ListAdressTypesApi extends BaseApi {
    idUser : string = "";
    idCompany : string = "";
    constructor() {
        super("dataaccess", "Settings");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
        this.idCompany = userFromStorage.idCompany;
    }

    async GetListAdressesTypes() : Promise<IListAdressTypes[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var listAdressesTypes: IListAdressTypes[] = [];
            listAdressesTypes = response.data as IListAdressTypes[];
            return listAdressesTypes;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveListAdressTypes(listAdressType: IListAdressTypes) : Promise<string> {
        const json = this.getJsonSave(listAdressType);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateListAdressTypes(listAdressType: IListAdressTypes) : Promise<boolean> {
        const json = this.getJsonUpdate(listAdressType);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteListAdressTypes(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async inUseSetting(id: string) : Promise<boolean> {
        const json = this.getInUseJson(id);
        const response = await this.api.post('ExecWithResults', json);
        if (!response) return false;
        if (response.isSuccess) {
            const data = response.data as any[];
            return Number(data && data[0] && data[0].isInUse) === 1;
        } else {
            this.modelState = response.errorState;
            return false;
        }
    }

    private getInUseJson(id: string) : any {
        const json = {
            "spname": "dbo.IS_ADRESS_TYPE_IN_USE",
            "parameters": [{
                "Item1": "AdressTypeId ",
                "Item2": id
            }, {
                "Item1": "companyId ",
                "Item2": this.idCompany
            }]
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "ListAdressTypes",
                "Item2": "id"
            }, {
                "Item1": "ListAdressTypes",
                "Item2": "typeName"
            }, {
                "Item1": "ListAdressTypes",
                "Item2": "isFiscal"
            }, {
                "Item1": "ListAdressTypes",
                "Item2": "isPostal"
            }, {
                "Item1": "ListAdressTypes",
                "Item2": "isBilling"
            }],
            "tables": [{
                "Item1": "ListAdressTypes"
            }],
            "conditions": [{
                "Item1": "ListAdressTypes",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "ListAdressTypes",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": this.idCompany
            }],
            "orderBy": [{
                "Item1": "ListAdressTypes.typeName"
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "ListAdressTypes",
            "conditions": [{
                "Item1": "ListAdressTypes",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(listAdressType: IListAdressTypes) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "typeName",
                "Item2": listAdressType.typeName
            }, {
                "Item1": "isBilling",
                "Item2": listAdressType.isBilling
            }, {
                "Item1": "isFiscal",
                "Item2": listAdressType.isFiscal
            }, {
                "Item1": "isPostal",
                "Item2": listAdressType.isPostal
            }, {
                "Item1": "idCompany",
                "Item2": this.idCompany
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "ListAdressTypes"
        };
        return json;
    }

    private getJsonUpdate(listAdressType: IListAdressTypes) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "typeName",
                "Item2": listAdressType.typeName
            }, {
                "Item1": "isBilling",
                "Item2": listAdressType.isBilling
            }, {
                "Item1": "isFiscal",
                "Item2": listAdressType.isFiscal
            }, {
                "Item1": "isPostal",
                "Item2": listAdressType.isPostal
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "ListAdressTypes",
            "keyvalue": listAdressType.id
        };
        return json;
    }
}
